import React from "react";
import ConfirmationModal from "../../shared/ConfirmationModal";

const mayNotProceedMessage =
  "The job to charge Shluchim for approved reward requests may be running now. " +
  "Rejecting an approved request may result in overcharging or other issues. " +
  "Please try again after 4 AM ET.";

export default function ApproveRejectRewardRequestModal(props) {
  const {
    approveRejectRewardRequest: {
      errorMessage,
      loading,
      action,
      rewardRequest,
    },
    onCancel,
    onConfirm,
    isApproving,
    isRejecting,
    isRejectingApprovedRequest,
  } = props;

  const isInvoicesJobWindow = (() => {
    if (!isRejectingApprovedRequest) {
      return false;
    }
    const nowET = new Date(
      new Date().toLocaleString("en-US", { timeZone: "America/New_York" }),
    );
    const currentHour = nowET.getHours();
    return currentHour >= 2 && currentHour < 4;
  })();

  const mayNotProceed = isInvoicesJobWindow && isRejectingApprovedRequest;

  return (
    <ConfirmationModal
      cancel={onCancel}
      confirm={() => {
        if (mayNotProceed) {
          alert(mayNotProceedMessage);
          return;
        }
        onConfirm();
      }}
      errorMessage={errorMessage}
      loading={loading}
      message={
        <>
          {mayNotProceed && (
            <div
              style={{ color: "red", fontWeight: 700, marginBottom: "12px" }}
            >
              {mayNotProceedMessage}
            </div>
          )}
          Are you sure you want to {action} this
          {isRejectingApprovedRequest && " approved"} request
          {rewardRequest?.rewardName
            ? ` for ${rewardRequest.rewardName} reward`
            : ""}
          ?
          <div style={{ fontSize: "14px", marginTop: "16px" }}>
            {isApproving
              ? "Please note that students are notified of reward approvals."
              : isRejectingApprovedRequest
                ? "This will reverse the approval and restore the student's credits. Students are not notified of rejections."
                : "Please note that students are not notified of reward rejections."}
          </div>
          {isRejecting && rewardRequest?.invoiceDetails?.length > 0 && (
            <div className="accent-text-dark fs-14 fw-700 mt-12">
              This reward request has paid invoices. Rejecting will not
              automatically refund these amounts:
              <ul style={{ margin: "8px 0 0", paddingLeft: "20px" }}>
                {rewardRequest.invoiceDetails.map((inv, idx) => (
                  <li key={idx}>
                    ${inv.amountPaid.toFixed(2)} — {inv.shliachFirstName}{" "}
                    {inv.shliachLastName} ({inv.chabadHouseName})
                  </li>
                ))}
              </ul>
            </div>
          )}
        </>
      }
      show={true}
    />
  );
}
